export default __webpack_public_path__ + "static/media/finance.20a7e22e.svg";